import background from "../assets/bg.jpg"
import Menubar from "../components/Menubar";
// import { ACCENT_1_COLOR } from "../constants/color";
import { useState } from "react";
import {
  Box,
  VStack,
  Heading,
  Text,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  SimpleGrid,
  useToast
} from "@chakra-ui/react";
import { ACCENT_1_COLOR, PRIMARY_COLOR, SECONDARY_COLOR } from "../constants/color";
import CustomButton from "../components/CustomButton";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";

export default function Contact() {
  const {t} = useTranslation();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const toast = useToast();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!name || !email || !message) {
      toast({
        title: t("requiredTitle"),
        description: t("requiredDesc"),
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
      return;
    }

    const msg = `Hi Admin Mugai Ryu Indonesia
    Saya *${name}*

    Ingin menanyakan hal sebagai berikut:
    ${message}`;

    const encodedMessage = encodeURIComponent(msg);

    const phoneNumber = "6285704004657";

    const waLink = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

    toast({
      title: "Message Sent Successfully",
      description: "Thank you for reaching out. We will get back to you shortly.",
      status: "success",
      duration: 5000,
      isClosable: true,
    });
    setName("");
    setEmail("");
    setMessage("");
    window.open(waLink, "_blank");
  };

  return (
    <Box display={"flex"} minH={"100vh"} width={"100vw"} background={`transparent url(${background})`}
      bgRepeat={"repeat"} pb={"24px"}>
      <Helmet>
        <title>{t("contactUsTitle")}</title>
        <meta name="description" content={t("contactUsDesc")} />
        <link rel="canonical" href="https://mugairyu-indonesia.com/contact" />
      </Helmet>
      <Box width={"100vw"}>
        <Menubar />
        <Box width={"100vw"} px={{ base: "5vw", lg: "20vw" }} display={"flex"} flexDir={"column"} textAlign={"left"} mt={"18px"}>
          {/* Title Header Section */}
          <VStack align="flex-start" spacing="1" mb="32px">
            <Text textColor={ACCENT_1_COLOR} fontSize="30px">
              {t("contactUs")}
            </Text>
          </VStack>

          {/* Core Layout Split */}
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={{ base: "40px", md: "80px" }}>

            {/* Column 1: The Interactive Form */}
            <Box
              bg="rgba(255, 255, 255, 0.03)"
              backdropFilter="blur(8px)"
              border="1px solid rgba(255, 255, 255, 0.08)"
              borderRadius="4px"
              p={{ base: "6", md: "8" }}
              boxShadow="0 10px 30px rgba(0, 0, 0, 0.2)"
            >
              <form onSubmit={handleSubmit}>
                <VStack spacing="5">
                  <FormControl isRequired>
                    <FormLabel color={PRIMARY_COLOR} fontSize="14px" className="cormorant-garamond-normal">
                      {t("name")}
                    </FormLabel>
                    <Input
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      placeholder={t("namePlaceholder")}
                      bg={SECONDARY_COLOR}
                      border="1px solid "
                      borderColor={"gray.300"}
                      borderRadius="2px"
                      _focus={{ borderColor: ACCENT_1_COLOR, boxShadow: "none" }}
                      _placeholder={{ color: "gray.600", fontSize: "14px" }}
                    />
                  </FormControl>

                  <FormControl isRequired>
                    <FormLabel color={PRIMARY_COLOR} fontSize="14px" className="cormorant-garamond-normal">
                      {t("emailAddress")}
                    </FormLabel>
                    <Input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder={t("emailPlaceholder")}
                      bg={SECONDARY_COLOR}
                      border="1px solid "
                      borderColor={"gray.300"}
                      borderRadius="2px"
                      _focus={{ borderColor: ACCENT_1_COLOR, boxShadow: "none" }}
                      _placeholder={{ color: "gray.600", fontSize: "14px" }}
                    />
                  </FormControl>

                  <FormControl isRequired>
                    <FormLabel color={PRIMARY_COLOR} fontSize="14px" className="cormorant-garamond-normal">
                      {t("message")}
                    </FormLabel>
                    <Textarea
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      placeholder={t("messagePlaceholder")}
                      bg={SECONDARY_COLOR}
                      border="1px solid "
                      borderColor={"gray.300"}
                      borderRadius="2px"
                      rows={6}
                      _focus={{ borderColor: ACCENT_1_COLOR, boxShadow: "none" }}
                      _placeholder={{ color: "gray.600", fontSize: "14px" }}
                    />
                  </FormControl>

                  <CustomButton onClick={handleSubmit} w="100%">
                    {t("sendMessage")}
                  </CustomButton>
                </VStack>
              </form>
            </Box>

            {/* Column 2: Dojo Location & Information Details */}
            <VStack align="flex-start" spacing="6" pt="2">
              <Box>
                <Heading as="h3" size="sm" color={ACCENT_1_COLOR} mb="2" className="cormorant-garamond-bold">
                  {t("trainingSchedule")}
                </Heading>
                <Text fontSize="14px" color={PRIMARY_COLOR}>
                  <strong>Mugai Ryu {t("malang")}</strong>
                </Text>
                <Text fontSize="14px" color={PRIMARY_COLOR}>
                  Aula Serbaguna Museum Brawijaya, Jl Ijen 25A, Malang
                </Text>
                <Text fontSize="14px" color={PRIMARY_COLOR}>
                  {t("thursday")}: 19.00-21.00 & {t("sunday")}: 07.00-08.45
                </Text>

                <Text fontSize="14px" color={PRIMARY_COLOR} mt="12px">
                  <strong>Mugai Ryu {t("surabaya")}</strong>
                </Text>
                <Text fontSize="14px" color={PRIMARY_COLOR}>
                  Lagoon Avenue Mall, Surabaya
                </Text>
                <Text fontSize="14px" color={PRIMARY_COLOR}>
                  {t("wednesday")}: 19.00-21.00
                </Text>

                <Text fontSize="14px" color={PRIMARY_COLOR} mt="12px">
                  <strong>Mugai Ryu {t("sidoarjo")}</strong>
                </Text>
                <Text fontSize="14px" color={PRIMARY_COLOR}>
                  Puri Indah Sport, Perumahan Blok AJ.1-7, Sidoarjo
                </Text>
                <Text fontSize="14px" color={PRIMARY_COLOR}>
                  {t("friday")}: 19.00-21.00
                </Text>
              </Box>

              <Box>
                <Heading as="h3" size="sm" color={ACCENT_1_COLOR} mb="2" className="cormorant-garamond-bold">
                  {t("directInquiries")}
                </Heading>
                <Text fontSize="14px" color={PRIMARY_COLOR}>
                  Email: info@mugairyu.id
                </Text>
              </Box>
            </VStack>

          </SimpleGrid>

          {/* <Text textColor={ACCENT_1_COLOR} fontSize={"30px"}>Mugai Ryu Indonesia</Text>
            <Text textColor={"#765946"} fontStyle={"italic"} fontSize={"18px"} mb={"24px"}>Mugai Ryu Iaido & Kenjutsu Dojo</Text>
            <Text mb={"12px"} as={"b"} textColor={"#43525a"}>Yohanes Vandi Kurniawan</Text>

            <Text>Phone: +62 811 1111 1111</Text>
            <Text mb={"12px"}>eMail: email@email.com</Text>

            <Text mb={"24px"} as={"b"} textColor={"#43525a"}>In our dojo varying types of people of different age join together in training in a respectful and familiar atmosphere. It does not matter, whether you are experienced and physically in shape or untrained and daring to take the very first steps in martial arts. Whether you are just looking for some balancing from everyday life or wish to train professionally or even want to open your own school. We will teach you according to your personal needs.</Text>

            <Text textColor={"#765946"} fontStyle={"italic"} fontSize={"18px"} mb={"12px"}>Training Time</Text>
            <Box  overflowX={"scroll"}>
              <Table minW={"500px"}>
                <Thead>
                  <Tr>
                    <Th>Dojo</Th>
                    <Th>Location</Th>
                    <Th>Time</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  <Tr>
                    <Td>Mugai Ryu Malang City</Td>
                    <Td>Aula Serbaguna Museum Brawijaya, Jl Ijen 25A, Malang</Td>
                    <Td>Thursday 19.00-21.00 & Sunday 07.00-08.45</Td>
                  </Tr>
                  <Tr>
                    <Td>Mugai Ryu Surabaya City</Td>
                    <Td>Lagoon Avenue Mall, Surabaya</Td>
                    <Td>Wednesday 19.00-21.00</Td>
                  </Tr>
                  <Tr>
                    <Td>Mugai Ryu Sidoarjo Regency</Td>
                    <Td>Puri Indah Sport, Perumahan Blok AJ.1-7, Sidoarjo</Td>
                    <Td>Friday 19.00-21.00</Td>
                  </Tr>
                </Tbody>
              </Table>
            </Box> */}
        </Box>
      </Box>
    </Box>
  );
}
